import React, { useState } from "react";
import Image from "next/image";
import HireFromMilesForm from "@/components/forms/hireFromMilesForm";

const AccountingTalentPoolMobileHFM = () => {
  const [isformPopupOpen, setformPopupOpen] = useState(false);

  const openformPopup = () => {
    setformPopupOpen(true);
  };

  const closeformPopup = () => {
    setformPopupOpen(false);
  };
  return (
    <section className="flex flex-col w-full bg-[#061A2F] relative bg-no-repeat bg-contain bg-bottom">
      <div className="text-center">
        <h2 className="font-semibold text-[14px] text-white mt-7">
          <span className="tracking-[-0.56px] leading-[normal] text-white">
            Leverage the World’s Largest <br></br>{" "}
            <span className="text-[24px] border-[#CA7216] leading-[normal] racking-[-0.96px] border-b-[4px] pb-[5px] text-white">
              Accounting Talent Pool
            </span>
          </span>
        </h2>
      </div>
      <div className="flex flex-col w-full gap-20 mb-10">
        <div className="w-full flex flex-col justify-center items-center">
          <h3 className="text-white mt-14 text-[20px] font-bold leading-6">
            Hire Accountants in <span className="text-[#3174d6]">India</span>
          </h3>
          <div className="flex justify-center items-center">
            <Image
              loading="lazy"
              src="/hire-from-miles/talent-in-india.png"
              alt="Hire Accountants in India"
              className=""
              width={364}
              height={364}
            />
          </div>

          <div className="flex flex-col gap-3">
            <ul className="list-disc text-white text-[16px] leading-6 font-medium">
              <li>Hire the best accounting talent in India</li>
              <li>Onboard in 7 days</li>
              <li>
                Preferred hiring partner of Big 4 & 220+ <br />
                MNCs in India
              </li>
            </ul>

            <div className="w-full mt-8 relative ">
              <div className="grp_btn flex items-center gap-2">
                <div className="know-more-arrow-container">
                  <Image
                    loading="lazy"
                    src="/hire-from-miles/know-more-arrow.svg"
                    alt=""
                    className="new_arrow mr-1"
                    width={14}
                    height={14}
                    quality={100}
                  />
                </div>
                <div
                  onClick={openformPopup}
                  className="know_more_btn_hireFromMiles w-full text-center text-[13px] font-semibold leading-9 cursor-pointer inline-block !px-10"
                >
                  Know More
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col justify-center items-center">
          <h3 className="text-white mt-14 text-[20px] font-bold leading-6">
            Hire Accountants in the <span className="text-[#FFBA08]">US.</span>
          </h3>
          <div className="flex justify-center items-center">
            <Image
              loading="lazy"
              src="/hire-from-miles/talent-in-us.png"
              alt="Hire Accountants in India"
              className=""
              width={390}
              height={409}
            />
          </div>

          <div className="flex flex-col gap-3">
            <ul className="list-disc text-white text-[16px] leading-6 font-medium">
              <li>
                Hire from a pool of 1200+ Accountants
                <br /> on W2
              </li>
              <li>No Visa sponsorship required</li>
              <li>Trusted by RSM & BDO alliance</li>
            </ul>

            <div className="w-full mt-8 relative">
              <div className="grp_btn flex items-center gap-2">
                <div className="know-more-arrow-container">
                  <Image
                    loading="lazy"
                    src="/hire-from-miles/know-more-arrow.svg"
                    alt=""
                    className="new_arrow mr-1"
                    width={14}
                    height={14}
                    quality={100}
                  />
                </div>
                <a
                  href="https://www.milestalenthub.com/accounting"
                  target="_blank"
                  className="know_more_btn_hireFromMiles w-full text-center text-[13px] font-semibold leading-9 cursor-pointer inline-block !px-10"
                >
                  Know More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isformPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div className="rounded-[14px] shadow-lg relative h-[auto] mx-auto w-[345px] bg-white p-4">
            <button
              onClick={closeformPopup}
              className="mt-4 text-[#878787] px-3 text-lg py-1 rounded absolute right-[10px] top-[16px] z-[9999]"
            >
              ✕
            </button>
            <HireFromMilesForm />
          </div>
        </div>
      )}
    </section>
  );
};

export default AccountingTalentPoolMobileHFM;
